"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumericInput = void 0;
const react_1 = __importStar(require("react"));
const numeric_input_styles_1 = require("./numeric-input.styles");
require("./numeric-input.types");
exports.NumericInput = (0, react_1.memo)((0, react_1.forwardRef)((props, ref) => {
    const { value = 0, maxValue, minValue = 0, onChange, step = 1, disabled, disabledDecrement, disabledIncrement, testId = 'numericInput', } = props;
    const isDisabledDecrement = (0, react_1.useMemo)(() => disabled ||
        disabledDecrement ||
        (typeof value === 'number' && value <= +minValue), [disabled, disabledDecrement, value, minValue]);
    const isDisabledIncrement = (0, react_1.useMemo)(() => disabled ||
        disabledIncrement ||
        !!(typeof value === 'number' && maxValue && value >= +maxValue), [disabled, disabledIncrement, value, maxValue]);
    const handleOnChange = (e) => {
        onChange(+e.target.value);
    };
    const increaseCount = () => {
        onChange(value + step);
    };
    const decreaseCount = () => {
        onChange(value - step);
    };
    return (react_1.default.createElement(numeric_input_styles_1.StyledNumericInput, null,
        react_1.default.createElement(numeric_input_styles_1.StyledButton, { onClick: decreaseCount, disabled: isDisabledDecrement, "data-testid": `${testId}.decrementButton` },
            react_1.default.createElement(react_1.Suspense, { fallback: null },
                react_1.default.createElement(numeric_input_styles_1.StyledMinus, { disabled: isDisabledDecrement }))),
        react_1.default.createElement(numeric_input_styles_1.StyledInput, Object.assign({}, props, { ref: ref, value: value, onChange: handleOnChange, disabled: disabled || (typeof value === 'number' && value <= +minValue), "data-testid": `${testId}.input` })),
        react_1.default.createElement(numeric_input_styles_1.StyledButton, { onClick: increaseCount, disabled: isDisabledIncrement, "data-testid": `${testId}.incrementButton` },
            react_1.default.createElement(react_1.Suspense, { fallback: null },
                react_1.default.createElement(numeric_input_styles_1.StyledPlus, { disabled: isDisabledIncrement })))));
}));
